import styled from 'styled-components';

export const FlightsSummaryStyled = styled.div`
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
      gap: 8px;

  .flightsSummary {
    &__titleContainer {
      display: flex;
      gap: 67px;
      align-items: center;
      font: var(--font-body-400-bold);

      &Subtitle {
        color: var(--color-sonata-primary-600);
        font: var(--font-info-600-bold);
      }
    }

    &__dataContainer {
      display: flex;
      gap: 8px;
      align-items: baseline;

      &Date {
        color: var(--color-sonata-primary-700);
        font: var(--font-body-400-regular);
      }

      &Separator {
        background: var(--color-sonata-primary-6  00);
        border-radius: 8px;
        padding: 1.5px;
        height: 12px;
        align-self: center;
      }

      &Total {
        color: var(--color-sonata-primary-800);
        font: var(--font-body-400-bold);
      }
    }
  }
`;
